import React from 'react';
import styled from 'styled-components';
import {
	FormControl,
	FormControlLabel,
	FormLabel,
	Radio,
	RadioGroup,
} from '@mui/material';

const ErrorWrapper = styled.div`
	padding-top: 2rem;

	span {
		color: ${(props) => props.theme.error};
		font-size: 1.3rem;
	}
`;

const CustomRadioGroup = ({
	id,
	label,
	required,
	disabled,
	value,
	source,
	error,
	onChange,
}) => (
	<>
		<FormControl>
			<FormLabel id={`${id}-label`}>{label}</FormLabel>
			<RadioGroup
				aria-labelledby={`${id}-label`}
				value={value}
				onChange={(_, newValue) => onChange(newValue)}
			>
				{source.map((radio, index) => (
					<FormControlLabel
						disabled={disabled}
						required={required}
						key={`${id}-radio-${index}`}
						value={radio.value}
						control={<Radio />}
						label={radio.label}
					/>
				))}
			</RadioGroup>
		</FormControl>
		{error && <ErrorWrapper>{error}</ErrorWrapper>}
	</>
);

export default CustomRadioGroup;
